module.exports = __webpack_public_path__ + "static/364086_0_0-64a114f9c21d9bd6c9096bf05cb07421.woff";